'use client'
import { useTranslations } from 'next-intl'
import { Controller, useForm } from 'react-hook-form'
import GoldLinkButton from '@/components/GoldLinkButton'
import { useSearchParams } from 'next/navigation'
import {
  useAddPriveAccount,
} from 'src/lib/api/mailingService'
import { useRouter } from 'navigation'
const PriveContact = ({ eventsPage = false, contactApi = false }) => {
  const t = useTranslations('privePage.prive-contact')
  const router = useRouter()
  const searchParams = useSearchParams()
  const { addPriveAccount } = useAddPriveAccount()

  const getUtmParameters = (searchParams) => {
    return {
      utmSource: searchParams.get('utm_source') || 'None',
      utmMedium: searchParams.get('utm_medium') || 'None',
      utmCampaign: searchParams.get('utm_campaign') || 'None',
      utmTerm: searchParams.get('utm_term') || 'None',
      utmContent: searchParams.get('utm_content') || 'None',
    }
  }
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      phoneNumber: '',
      socialMediaHandle: '',
      'job-role':'',
      industry: '',
      'services-interested-in': '',
      'why-in-prive': '',
    },
    mode: 'onChange',
  })
  const onSubmit = async (formData) => {
    try {
      let data = {}
      let utmValues = getUtmParameters(searchParams)
      data = {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        social_media_handle: formData.socialMediaHandle,
        job_role: formData['job-role'],
        industry: formData.industry,
        services_interested_in: formData['services-interested-in'],
        why_in_prive: formData['why-in-prive'],  
        utm_source: utmValues.utmSource,
        utm_medium: utmValues.utmMedium,
        utm_campaign: utmValues.utmCampaign,
        utm_term: utmValues.utmTerm,
        utm_content: utmValues.utmContent,
        url: window.location.href,
        referrer: document.referrer || 'None',
      }
      let response = null
      response = await addPriveAccount(data)
      if (response.meta.success) {
        router.push({
          pathname: '/success',
          query: { email: formData.email },
        })
      }
    } catch (error) {
      console.error('Error adding business account:', error)
    }
  }

  return (
    <div
      id='priveContact'
      className={`col-span-7  ${
        !contactApi ? 'shadow-contact-form bg-white py-[50px] px-[15px] md:px-6' : ''
      }  rounded-[10px]`}
    >
      <form className='flex flex-col gap-5 md:gap-[30px] ' onSubmit={handleSubmit(onSubmit)}>
        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.name')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='name'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                placeholder={t('form.placeholders.name')}
                    autoComplete='off'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.name
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.name?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.email')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='email'
              rules={{
                required: 'This field is required',
                pattern: {
                  value: /^[^@]+@[^@]+\.[^@]+$/,
                  message: 'Invalid email address',
                },
              }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    type='email'
                    autoComplete='off'
                    placeholder='anna.smith@example.com'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.email
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.email?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
      
          <div className='grid grid-cols-12 items-center '>
            <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
              {t('form.labels.phoneNumber')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name='phoneNumber'
                rules={{ required: 'This field is required' }}
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      autoComplete='off'
                      type='tel'
                      placeholder={t('form.placeholders.phoneNumber')}
                      className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                      {...field}
                      ref={null}
                    />
                    <p
                      className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                        errors.phoneNumber
                          ? 'translate-y-[7px] opacity-100'
                          : 'translate-y-0 opacity-0'
                      }  left-[10px] font-light absolute text-[10.5px]`}
                    >
                      {errors.phoneNumber?.message}
                    </p>
                  </>
                )}
              />
            </div>
          </div>
      

        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.socialMediaHandle')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='socialMediaHandle'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder={t('form.placeholders.socialMediaHandle')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.socialMediaHandle
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.socialMediaHandle?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.job-role')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='job-role'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder={t('form.placeholders.job-role')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors['job-role']
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors['job-role']?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.industry')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='industry'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder={t('form.placeholders.industry')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.industry
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.industry?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        <div className='grid grid-cols-12 items-center '>
          <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
            {t('form.labels.services-interested-in')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='services-interested-in'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder={t('form.placeholders.services-interested-in')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors['services-interested-in']
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors['services-interested-in']?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
     
          <div className='grid grid-cols-12 items-start '>
            <label className='col-span-full md:col-span-4 mb-1 md:mb-0 text-[14px] tracking-[0.2px] font-normal'>
              {t('form.labels.why-in-prive')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name={'why-in-prive'}
                control={control}
                render={({ field }) => (
                  <textarea
                    rows={6}
                    placeholder={t('form.placeholders.why-in-prive')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] tracking-[0.2px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                )}
              />
            </div>
          </div>
     
        <div className='flex items-center justify-end'>
          <GoldLinkButton
            text='Submit'
            hasGoldBackground
            className=' !px-6 !py-2 '
            textClassName='!text-[15px] font-extralight leading-[18px] tracking-[0.2px]'
            type='submitBtn'
            isShowRightArrow={false}
          />
        </div>
      </form>
    </div>
  )
}

export default PriveContact
